import React from 'react';
import AppHeader from 'components/Layout/AppHeader';
import { Box, Center, Flex, Loader } from '@mantine/core';
import { useAppHeaderStyles } from 'components/Layout/layoutStyles';

interface AppLayoutProps {
  children: React.ReactNode;
}

const ContentLoader = () => (
  <Center pt={100}>
    <Loader />
  </Center>
);

const AppLayout = ({ children }: AppLayoutProps) => {
  const { classes } = useAppHeaderStyles();
  return (
    <Flex direction="column">
      <AppHeader />
      <div className={classes.contentWrapper}>
        <Box className={classes.content}>
          <React.Suspense fallback={<ContentLoader />}>
            {children}
          </React.Suspense>
        </Box>
      </div>
    </Flex>
  );
};

export default AppLayout;
